import { PunkGameConfig } from "../../../PunkGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { GameAssets } from "../../../GameAssets";
import { Ease, TimelineMax, Bounce, TweenLite, Power3  } from "gsap";
import { ISymbolConfig, ISymbolDim } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/IReelSymbolData";
import { SymbolMultiplyCounter } from "./SymbolMultiplyCounter";
import { Sequence, ISequencePlay, ISequenceClip } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { BLEND_MODES, Texture, } from "pixi.js";
import { ReelItemMap, IReelItem, IItemTransform } from "../../../punkEngine/mapping/ReelItemMap";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { PunkSymbolData } from "../../../punkEngine/config/PunkSymbolData";
import { PunkSymbol } from "../../../punkEngine/PunkSymbol";

export interface ISymbolWinAnimation extends IReelItem {
    State:string;
    showSymbol?:boolean;
    duration?:number;
    ease?:any;
    sequenceConfig?:ISequencePlay;
    repeat?:number;
    followSymbol?:boolean;
}

export interface IParticleAnimation extends IReelItem {
    duration:number;
}

export interface IExpandingAnimation extends ISymbolWinAnimation {
    size:number;
    replace?:boolean;
    isBonus?:boolean;
    multValue?:number;
}

export interface IMultiplyAnimation extends ISymbolWinAnimation {
    value:string;
    symType?:string;
}

export interface IWinItem extends IReelItem {
    State:WinSymbolStateHandler;
    itemContainer:PIXI.Container;
    particles?:PIXI.Container;
    spine?:PIXI.spine.Spine;
    symbol?:Sequence;
    frame?:Sequence;
    mult?:SymbolMultiplyCounter;
}

class WinSymbolStateHandler extends ReelSymbolStates {

    public defineFrame(item:IWinItem):void{
        if(item.frame == undefined) item.frame = this.createSequence(item,1);
        item.frame!.resetToDefault();
        switch(this.state){
            case WinSymbolStateHandler.REVEAL:
                this.RevealFrame(item);
                break;
            case WinSymbolStateHandler.TRANSFORM:
                this.ScatterFrame(item);
                break;
            case WinSymbolStateHandler.WIN:
                this.WinFrame(item);
                break;
        }
    }

    public defineSymbol(item:IWinItem):void{
        const symbol:PunkSymbol = PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!;
        let size:string = symbol.stateType.state.toString();
        let symConfig:ISymbolConfig = symbol.symbolConfig;
        let texture:Texture[] | undefined = PunkSymbolData.getTextureFromConfig(symConfig, item.State.state, size);
        let dim:ISymbolDim | undefined = PunkSymbolData.getDimFromConfig(symConfig, item.State.state, size)!;

        if(dim == undefined) dim = symConfig.DIM!;
        if(texture == undefined) texture = [];
        if(item.symbol == undefined) item.symbol = this.createSequence(item,0);

        item.symbol.resetToDefault();
        item.symbol.visible = true;

        item.symbol.anchor.set(0.5,0.5);
        item.symbol.pivot.x += dim.PADDING_X; 
        item.symbol.pivot.y += dim.PADDING_Y;
        item.symbol.scale = dim.SCALE;
        item.symbol.zIndex = 0;

        item.symbol.setTexture(texture);
        item.itemContainer.sortChildren();
    }

    public defineSpine(item:IWinItem,symType?:string):void{
        const symbol:PunkSymbol = PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!;
        let size:string = symbol.stateType.state;
        if(item.spine != undefined){
            for(let i = 0; i < item.itemContainer.children.length;i++)
                if(item.itemContainer.children[i].name == "stupid"){
                    item.itemContainer.removeChildAt(i);
                    delete item.spine;
                }
        }

        if(item.State.equal(ReelSymbolStates.WIN)){
            if(item.spine == undefined  && !symbol.isWild){
                item.spine =  new PIXI.spine.Spine(GameResources.getSpineAsset("crack"));
                item.spine.zIndex = 3;
                item.spine.name = "stupid";
                let scales:number = [2, 1.8, 1.5 ,1 ,0.75 ,0.6 ,0.5][7 - parseInt(size,16)];
                if(size == "10") scales = 2;
                item.spine.scale.set(1,scales)
                item.itemContainer.addChild(item.spine);
            }
        }else if(item.State.equal(ReelSymbolStates.REVEAL)){
            item.spine = new PIXI.spine.Spine(GameResources.getSpineAsset("superX" + symType![1]));
            item.spine.zIndex = 1;
            item.spine.scale.set(1,1);
            item.spine.pivot.set(0,-90)
            item.itemContainer.addChild(item.spine);
        }
        item.spine!.name = "stupid";
        item.itemContainer.sortChildren();
    }

    public defineWildExpand(item:IWinItem,isBonus:boolean,size:string):void{
        const symbol:PunkSymbol = PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!;
        let symConfig:ISymbolConfig = symbol.symbolConfig;
        let texturePath:string =  isBonus ? "WildExpand6" : "WildExpand3";
        let texture:Texture[] | undefined = GameResources.getTextures(texturePath);
        let dim:ISymbolDim | undefined = PunkSymbolData.getDimFromConfig(symConfig, item.State.state, size.toString())!;

        if(dim == undefined) dim = symConfig.DIM!;
        if(texture == undefined) texture = [];
        delete item.symbol;
        item.symbol = this.createSequence(item,0);
        item.symbol.setTexture(texture);

        let clips3:ISequenceClip[] = [
            {
                name:"7",
                from:0,
                to:23
            },
            {
                name:"10",
                from:23,
            }
        ];

        let clips6:ISequenceClip[] = [
            {
                name:"4",
                from:0,
                to:23
            },
            {
                name:"5",
                from:23,
                to:45
            },
            {
                name:"7",
                from:45,
                to:67
            },
            {
                name:"8",
                from:67,
                to:89
            },
            {
                name:"10",
                from:89,
            }
        ]

        item.symbol.setClips(isBonus ? clips6 : clips3);
        item.symbol.resetToDefault();
        item.symbol.visible = true;

        item.symbol.anchor.set(0.5,0.5);
        item.symbol.pivot.x += dim.PADDING_X; 
        item.symbol.pivot.y += dim.PADDING_Y + ((180 - symbol.symbolHeight)*1.25);
        item.symbol.pivot.y += isBonus && size == "7" ? 90 : 0;
        item.symbol.pivot.y += isBonus && size == "10" ? 90 : 0;

        item.symbol.scale = dim.SCALE;

        item.symbol.zIndex = 0;
        item.itemContainer.sortChildren();
    }

    public defineMultiplier(item:IWinItem):void{
        if(item.mult != undefined) return;
        item.mult! = new SymbolMultiplyCounter()
        item.mult!.zIndex = 2;
        item.itemContainer.addChild(item.mult!);
        item.itemContainer.sortChildren();
    }

    protected WinFrame(item:IWinItem):void{
        let size:string = PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!.stateType.state.toString();
        const texture:Texture[] = GameResources.getTextures(GameAssets.WIN_FRAMES + size);
        item.frame!.pivot.set(0,0);//-24*0.5);
        item.frame!.zIndex = 4;
        item.frame!.setTexture(texture);
        item.frame!.visible = true;
    }

    protected ScatterFrame(item:IWinItem):void{
        const texture:Texture[] = GameResources.getTextures("WildFire");
        item.frame!.blendMode = BLEND_MODES.ADD;
        item.frame!.setTexture(texture);
    }

    protected RevealFrame(item:IWinItem):void{
        const texture:Texture[] = GameResources.getTextures("ExpandingFrame");
        item.frame!.blendMode = BLEND_MODES.ADD;
        item.frame!.scale.set(2,2);
        item.frame!.setTexture(texture);
    }

    protected createSequence(item:IWinItem,index:number):Sequence{
        const seq:Sequence =  new Sequence({ textures: [] });
        seq.zIndex = index;
        seq.alpha = 0;
        seq.anchor.set(0.5,0.5);
        item.itemContainer.addChild(seq);
        item.itemContainer.sortChildren();
        return seq;
    }
}

export class StateSymbolWin extends ReelItemMap {
    
    private static _instance:StateSymbolWin;
    protected _items:IWinItem[] = [];
    protected _timeline:TimelineMax;

    protected _idleTime:TimelineMax;

    protected dontUpdatePos:boolean = false;

    constructor(){
        super();
        if(!StateSymbolWin._instance) StateSymbolWin._instance = this;
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.WIN_FRAMES.name).addChild(this);
    }

    public static get instance():StateSymbolWin{
        return this._instance;
    }

    // Animation players.
    public playSymbolAnimation(config:ISymbolWinAnimation):TimelineMax{
        if(!PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!) return new TimelineMax();
        const item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        item.State.defineSymbol(item);
        
        if(config.State == ReelSymbolStates.REVEAL) this.dontUpdatePos = true;
        
        this._timeline = new TimelineMax({
            onUpdate: () => config.followSymbol ? this.getSymbolTransformData(item, item.itemContainer,true) : {},
            repeat: config.repeat,
            repeatDelay: 0,
        });

        let maxDuration:number = item.symbol!.totalDuration;
        if(config.duration != undefined) maxDuration = config.duration;
        item.symbol!.alpha = 1;
        
        this._timeline.add([
            () => PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(config.showSymbol != undefined ? true : false),
            () => item.symbol!.playAnimation(),
        ],0)
        this._timeline.to(this,maxDuration,{});
        this._timeline.add([
            () => item.symbol!.alpha = 0,
            () => PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(true),
            () => this.dontUpdatePos = false,
        ])
        return this._timeline;
    }

    public playFrameAnimation(config:ISymbolWinAnimation):TimelineMax{
        if(!PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!) return new TimelineMax();
        const item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        item.State.defineFrame(item);

        this._timeline = new TimelineMax({
            onUpdate: () => config.followSymbol ? this.getSymbolTransformData(item, item.itemContainer, false) : {},
            repeat: config.repeat,
            repeatDelay: 0,
        });

        const frameDuration:number = item.frame!.totalDuration;

        let maxDuration:number = frameDuration;
        if(config.duration != undefined) maxDuration = config.duration;
        // Symbol
        this._timeline.add([
            () => item.frame!.alpha = 1,
            () => item.frame!.playAnimation({duration:maxDuration}),
        ],0)
        this._timeline.to(this,maxDuration,{});
        // Symbol
        this._timeline.add(() => item!.frame!.alpha = 0);
        return this._timeline;
    }

    public resetIdleTimeline():void{
        if(this._idleTime) this._idleTime.totalProgress(1);
        this._idleTime = new TimelineMax();
    }

    public playIdleSymbolWinAnimation(config:ISymbolWinAnimation):TimelineMax{
        if(!PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!) return new TimelineMax();
        const item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        item.State.defineFrame(item);
        item.State.defineSymbol(item);

        const duration:number = config.duration ? config.duration : 0;
       
        const tl:TimelineMax = new TimelineMax({
            onStart:() => {
                item.symbol!.alpha = 1;
                PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(config.showSymbol != undefined ? true : false);
            },
            onComplete:() => {
                item.symbol!.alpha = 0;
                PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(true);
            }
        });
        // Symbol
        tl.add([
            () => { item.frame!.scale.set(1.1,1.1) },
            item.symbol!.playAnimation({ duration: item.symbol!.textures.length == 1 ? duration : undefined,
                 onCompleteCallback:() => {
                     item.symbol!.alpha = 0;
                     PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(true);
                },
            }),
        ])
        tl.to(item.frame! , duration*0.1,{alpha:1, ease : config.ease},0);
        tl.to(item.frame!.scale , duration*0.5,{x:1,y:1, ease : Bounce.easeOut},0);
        tl.to(item.frame! , duration*0.2,{alpha:0, ease : config.ease}, duration*0.8);

        this._idleTime.add(tl,this._idleTime.totalTime());
        // // Symbol
        return this._idleTime;
    }

    public playSymbolStartWinAnimation(config:ISymbolWinAnimation):TimelineMax{
        if(!PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!) return new TimelineMax();
        const item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        item.State.defineFrame(item);
        item.State.defineSymbol(item);

        const duration:number = config.duration ? config.duration : 0;
        const tl:TimelineMax = new TimelineMax();
        // Symbol
        tl.add([
            () => item.symbol!.alpha = 1,
            () => PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(config.showSymbol != undefined ? true : false),
            () => item.symbol!.playAnimation(),
        ],0)
        // Frame
        tl.add([
            TweenLite.fromTo(item.frame! , duration*0.1,{alpha:0},{alpha:1, ease : config.ease}),
            TweenLite.fromTo(item.frame!.scale , duration*0.5,{x:1.1,y:1.1}, {x:1,y:1, ease : Bounce.easeOut}),
        ],0)

        return tl;
    }

    public playSymbolStopWinAnimation(config:ISymbolWinAnimation):TimelineMax{
        if(!PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!) return new TimelineMax();
        const item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);

        const duration:number = config.duration ? config.duration : 0;
        const tl:TimelineMax = new TimelineMax();
        tl.add([
            () => PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(true),
            TweenLite.to(item.symbol! , duration,{alpha:0, ease : config.ease}),
            TweenLite.to(item.frame! , duration,{alpha:0, ease : config.ease}),
        ])
    
        return tl;
    }

    public playMultiplyAnimation(config:IMultiplyAnimation):TimelineMax{
        if(!PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!) return new TimelineMax();
        let item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        item.State.defineMultiplier(item);
        let tl:TimelineMax = new TimelineMax({ onUpdate:() => { this.updateItemTransform(item); }});

        const valNr:number= parseFloat(config.value);

        let offsetScale:number = item.mult!.DEFAULT_TEXT_STYLE.fontSize as number;
        item.mult!.style.fontSize = offsetScale + ((valNr-1)*5);

        const pivotOffsetTo:number = [270,324,360][valNr-2]/4;

        // Counter
        tl.add(() => item.mult!.visible = true)
        tl.add(() => item.mult!.text = "x"  + config.value);
        tl.fromTo(item.mult!.pivot, config.duration != undefined ? config.duration :0 , {y:0}, {y:pivotOffsetTo,ease:Bounce.easeOut},0 );
        tl.fromTo(item.mult!.scale, config.duration != undefined ? config.duration :0 , {y:0.9,x:0.9}, {y:1,x:1,ease:Bounce.easeOut},0 );
        return tl;
    }

    public playSuperMultiplyAnimation(config:IMultiplyAnimation):TimelineMax{
        if(!PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!) return new TimelineMax();
        let item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        item.State.defineSymbol(item);
        item.State.defineSpine(item,config.symType);
        const countValue:number = parseFloat(config.value);
        const spineDuration:number = countValue == 10 ? MathHelper.frameToSeconds(10) : MathHelper.frameToSeconds(19);

        let tl:TimelineMax = new TimelineMax({
            onStart:() => {
                item.spine!.alpha = 1;
                item.symbol!.alpha = 1;
                item.symbol!.playAnimation();
                this.updateItemTransform(item);
                PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(false);
                item.spine!.visible = true;
                item.spine!.state.setAnimation(0, "X"+countValue, false);
            },
            onUpdate:() => {
                const nt:number = tl.time()/spineDuration;
                if(nt <= 1){
                    let val:number = Math.floor(countValue*nt);
                    item.mult!.text = "x" + val;
                    item.mult!.scale.set(1+val/50,1+val/50);
                }
            }
        });
        tl.add(() => item.mult!.text = "x" + config.value, spineDuration);
        tl.to( item.mult!.scale,0.2,{x:1+ countValue/40, y:1+countValue/40},spineDuration)
        tl.to( item.mult!.scale,0.2,{x:1.1, y:1.1, ease:Bounce.easeOut},spineDuration+0.2)
        return tl;
    }

    public playSpineAnimation(config:ISymbolWinAnimation):TimelineMax{
        if(PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!.isWild) return new TimelineMax();
        let item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        item.State.defineSpine(item);

        let tl:TimelineMax = new TimelineMax({onStart:() => {
            item.spine!.visible = true;
            item.spine!.alpha = 1;
        }})
        // Counter
        tl.add(() => {
            try{ item.spine!.state.setAnimation(0, "Shatter",false) } catch{}
        })
        // item.spine!.state.timeScale = 2;
        return tl;
    }

    public playSpineEndAnimation(config:ISymbolWinAnimation):TimelineMax{
        let item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        if(PunkEngineManager.getReel(config.ReelID).getSymbol(config.SymID)!.isWild) return new TimelineMax();
        let tl:TimelineMax = new TimelineMax();
        // Counter
        tl.to(item.spine!, config.duration!,{alpha:0})
        tl.add(() => item.spine!.visible = false)
        return tl;
    }

    public HideMulti(config:ISymbolWinAnimation):TimelineMax{
        let tl:TimelineMax = new TimelineMax();
        let item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        if(item.mult && item.mult.visible){
            tl.to(item.mult!,0.3, {alpha: 0});
            tl.add(() => item.mult!.visible = false);
        } 
        return tl;
    }

    public DropMulti(config:ISymbolWinAnimation):TimelineMax{
        let tl:TimelineMax = new TimelineMax();
        let item:IWinItem = this.getItem(config.ReelID, config.SymID, config.State);
        if(item.mult == undefined) return tl;
        const pivotOffsetFrom:number = item.mult!.pivot.y;
        tl.fromTo(item.mult!.pivot, config.duration != undefined ? config.duration :0 , {y:pivotOffsetFrom}, {y:-pivotOffsetFrom,ease:Bounce.easeOut},0 );
        return tl;
    }

    // Functions
    protected updateItemTransform(item:IWinItem,useMap:boolean = true):void{
        if(item == undefined || this.dontUpdatePos || this._items.length == 0) return;

        const transformData:IItemTransform = this.getSymbolTransformData(item, item.itemContainer, useMap)!;
        item.itemContainer.position = transformData.position;
        item.itemContainer.scale = transformData.scale;

    }

    public hideItems():void{
        this._items.forEach((item:IWinItem) => {
            if(PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!)
                PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(true);

            if(item.symbol) item.symbol.visible = false;
            if(item.frame) item.frame.visible = false;
        });
    }

    public cleanItems():void{
        this._items.forEach((item:IWinItem) => {
            if(PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)! && PunkEngineManager.getReel(item.ReelID).isActive)
                PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!!.setVisibleForSymbol(true);
        });
        super.reset();
    }

    public fadeOutMult(reelID:number):void{
        const tl:TimelineMax = new TimelineMax();
        for(let i = 0; i < this._items.length;i++){
            if(this._items[i] && this._items[i].ReelID == reelID){
                let target:IWinItem = this._items[i];
                if(target.mult){
                    tl.to(target.mult,0.2,{alpha:0, onUpdate: () => { this.updateItemTransform(target, false)}, ease:Power3.easeIn} ,0)
                } 
            }
        }
        tl.play();
    }

    public getExistingItem(reelID:number,symID:number,):IWinItem | undefined{
        for(let id:number = 0; id < this._items.length; id++){
            if(this._items[id] && (this._items[id] as IWinItem).ReelID == reelID && (this._items[id] as IWinItem).SymID == symID) return this._items[id] as IWinItem;
        }
        return undefined;
    }
    
    // Creations
    public getItem(reelID:number,symID:number, state:string):IWinItem{
        let item:IWinItem | undefined = this.getExistingItem(reelID, symID) as IWinItem;
        if(item){
            this.updateItemTransform(item);
            item.State.set(state);
            return item;
        }

        item = super.createItem(reelID, symID, { itemContainer: new PIXI.Container(), State: new WinSymbolStateHandler(ReelSymbolStates.NORMAL)}) as IWinItem;
        item.itemContainer.zIndex = reelID*PunkGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT + symID;
        this._items.push(item);
        this.addChild(item.itemContainer);
        this.sortChildren();
        this.updateItemTransform(item);
        item.State.set(state);
        return item;
    }
}